module.exports = __webpack_public_path__ + "img/pantanal.251b8195.png";